import { Injectable } from '@angular/core';
import {
  ISignatureConfigService,
  ISignatureConsentService,
  ISignatureFormDataService,
  ISignatureFormGroupService,
  ISignatureProviderService,
} from '../../../interfaces/isignatureproviderservice';
import { DocusignConfigService } from './docusign-config.service';
import { DocusignConsentService } from './docusign-consent.service';
import { DocusignFormDataService } from './docusign-form-data.service';
import { DocusignFormGroupService } from './docusign-form-group.service';

@Injectable({
  providedIn: 'root',
})
export class DocusignSignatureProviderService implements ISignatureProviderService {
  constructor(
    private signatureConfigService: DocusignConfigService,
    private signatureConsentService: DocusignConsentService,
    private signatureFormDataService: DocusignFormDataService,
    private signatureFormGroupService: DocusignFormGroupService
  ) {}

  getSignatureConfigService(): ISignatureConfigService {
    return this.signatureConfigService;
  }

  getSignatureConsentService(): ISignatureConsentService {
    return this.signatureConsentService;
  }

  getSignatureFormDataService(): ISignatureFormDataService {
    return this.signatureFormDataService;
  }

  getSignatureFormGroupService(): ISignatureFormGroupService {
    return this.signatureFormGroupService;
  }
}
